<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item v-if="isMenu" style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="addTem">添加</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button-group>
                <el-button icon="el-icon-document" size="small" :loading="exportLoading" @click="exportExcel">导出Excel</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="ordernum"
                fixed
                label="订单号"
                show-overflow-tooltip
                min-width="120">
              </el-table-column>
              <el-table-column
                fixed
                label="生产单号"
                align="center"
                show-overflow-tooltip
                min-width="120">
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                align="center"
                label="客户"
                show-overflow-tooltip
                width="100">
              </el-table-column>
              <el-table-column
                prop="spurDate"
                label="应申购日期"
                align="center"
                show-overflow-tooltip
                width="120">
              </el-table-column>
              <el-table-column
                prop="purDate"
                show-overflow-tooltip
                label="申购日期"
                align="center"
                width="120">
              </el-table-column>
              <el-table-column
                prop="proDept"
                label="申购部门"
                align="center"
                show-overflow-tooltip
                width="100">
              </el-table-column>
              <el-table-column
                prop="material"
                align="left"
                label="物料名称"
                show-overflow-tooltip
                width="200">
              </el-table-column>
              <el-table-column
                prop="supplier"
                align="center"
                show-overflow-tooltip
                label="供应商"
                width="100">
              </el-table-column>
              <el-table-column
                width="100"
                align="center"
                show-overflow-tooltip
                label="采购周期(天)">
                <template slot-scope="scope">
                  <span>{{ scope.row.proPer }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="sproPlan"
                show-overflow-tooltip
                label="采购计划交期"
                align="center"
                width="120">
              </el-table-column>
              <el-table-column
                prop="proPlan"
                show-overflow-tooltip
                align="center"
                label="实际回厂日期"
                width="120">
              </el-table-column>
              <el-table-column
                prop="remark"
                show-overflow-tooltip
                align="left"
                label="备注"
                min-width="200">
              </el-table-column>
              <el-table-column
                prop="username"
                show-overflow-tooltip
                align="center"
                label="操作人"
                width="100">
              </el-table-column>
              <el-table-column
                prop="time"
                show-overflow-tooltip
                align="center"
                label="时间"
                width="200">
              </el-table-column>
              <el-table-column
                v-if="isMenu"
                label="操作"
                align="center"
                width="200"
                fixed="right">
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editTem(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteTem(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="100px" size="small">
            <el-row>
              <el-col :span="12">
                <el-form-item label="应申购日期" prop="spurDate">
                  <el-date-picker
                    v-model="addForm.spurDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申购日期" prop="purDate">
                  <el-date-picker
                    v-model="addForm.purDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="申购部门" prop="proDept">
                  <el-input v-model="addForm.proDept" placeholder="请输入申购部门名称" clearable maxlength="20" show-word-limit />
                </el-form-item>
                <el-form-item label="选择订单" prop="orderid">
                  <OrderChoose :key="key" v-model="addForm.orderid" :oldorderid="addForm.oldorderid"></OrderChoose>
                </el-form-item>
                <el-form-item label="物料名称" prop="material">
                  <el-input v-model="addForm.material" placeholder="请输入物料名称" clearable maxlength="100" show-word-limit />
                </el-form-item>
                <el-form-item label="供应商" prop="supplier">
                  <el-input v-model="addForm.supplier" placeholder="请输入供应商" clearable maxlength="100" show-word-limit />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="采购周期" prop="proPer">
                  <el-input v-model="addForm.proPer" show-word-limit>
                    <template slot="append">天</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="采购计划交期" prop="sproPlan">
                  <el-date-picker
                    v-model="addForm.sproPlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际回厂日期" prop="proPlan">
                  <el-date-picker
                    v-model="addForm.proPlan"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="请输入备注" clearable show-word-limit />
            </el-form-item>
          </el-form>
          <div style="float: right">
            <el-button type="primary" size="mini" icon="el-icon-document-checked" :loading="btnLoading" @click="submitTem">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  addOrEditPurchaseControl,
  deletePurchaseControl,
  exportPurchaseControlOfferExcel,
  getPurchaseControlList
} from '@/api/work'
import { getUserWorkRule } from '@/api/user'
import OrderChoose from '@/components/OrderChoose/index'

export default {
  name: 'cggk',
  components: { OrderChoose },
  data() {
    const validateProPer = (rule, value, callback) => {
      if (value !== null && value !== '' && value !== undefined) {
        const r = /^\+?[1-9][0-9]*$/ // 正整数
        if (!r.test(value)) {
          callback(new Error('请输入正确的正整数'))
        } else {
          if (parseInt(value) >= 0) {
            callback()
          }
        }
      } else {
        callback(new Error('请输入采购周期'))
      }
    }
    return {
      searchForm: {
        search: ''
      },
      key: '',
      tableData: [],
      MenuList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      btnLoading: false,
      exportLoading: false,
      isMenu: false,
      dialogTitle: '',
      dialogVisible: false,
      addForm: {
        proid: null,
        spurDate: '',
        purDate: '',
        sproPlan: '',
        proPlan: '',
        material: '',
        supplier: '',
        proPer: 0,
        proDept: '',
        orderid: '',
        oldorderid: '',
        remark: ''
      },
      rules: {
        spurDate: [{ required: true, message: '请选择应申购日期', trigger: 'change' }],
        purDate: [{ required: true, message: '请选择申购日期', trigger: 'change' }],
        sproPlan: [{ required: true, message: '请选择计划交期', trigger: 'change' }],
        // proPlan: [{ required: true, message: '请选择实际回厂日期', trigger: 'change' }],
        orderid: [{ required: true, message: '请选择订单', trigger: 'change' }],
        material: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],
        supplier: [{ required: true, message: '请输入供应商', trigger: 'blur' }],
        proDept: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
        proPer: [{ required: true, trigger: 'blur', validator: validateProPer }],
        // remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getMenu()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getMenu() {
      const data = {
        userid: this.user.dUserid,
        rule: this.user.rank,
        type: 0
      }
      getUserWorkRule(data).then(response => {
        for (const m of response.data) {
          if (m.name === '生产管理') {
            for (const menu of m.menulst) {
              if (menu.dNum === 'cggk-edit') {
                this.isMenu = true
                break
              }
            }
            break
          }
        }
        this.getData()
      })
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.searchForm.search,
        userid: this.user.dUserid
      }
      getPurchaseControlList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        const data = {
          search: this.searchForm.search,
          userid: this.user.dUserid
        }
        this.exportLoading = true
        exportPurchaseControlOfferExcel(data).then(response => {
          this.exportLoading = false
          const _this = this
          const xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              const blob = this.response
              const a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    deleteTem(row) {
      this.$confirm('您确定要删除此采购管控吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deletePurchaseControl({ proid: row.proid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    editTem(row) {
      this.dialogTitle = '修改采购管控'
      this.addForm.proid = row.proid
      this.addForm.spurDate = row.spurDate
      this.addForm.purDate = row.purDate
      this.addForm.sproPlan = row.sproPlan
      this.addForm.proPlan = row.proPlan
      this.addForm.material = row.material
      this.addForm.supplier = row.supplier
      this.addForm.proPer = row.proPer
      this.addForm.proDept = row.proDept
      this.addForm.orderid = ''
      this.addForm.oldorderid = row.orderid
      this.addForm.remark = row.remark
      this.key = new Date().getTime()
      this.dialogVisible = true
    },
    addTem() {
      this.dialogTitle = '添加采购管控'
      this.addForm.proid = '0'
      this.addForm.spurDate = ''
      this.addForm.purDate = ''
      this.addForm.sproPlan = ''
      this.addForm.proPlan = ''
      this.addForm.material = ''
      this.addForm.supplier = ''
      this.addForm.proPer = 0
      this.addForm.proDept = ''
      this.addForm.orderid = ''
      this.addForm.oldorderid = ''
      this.addForm.remark = ''
      this.key = new Date().getTime()
      this.dialogVisible = true
    },
    submitTem() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            const data = {
              proid: this.addForm.proid,
              spurDate: this.addForm.spurDate,
              purDate: this.addForm.purDate,
              sproPlan: this.addForm.sproPlan,
              proPlan: this.addForm.proPlan,
              material: this.addForm.material,
              supplier: this.addForm.supplier,
              proPer: this.addForm.proPer,
              proDept: this.addForm.proDept,
              orderid: this.addForm.orderid,
              remark: this.addForm.remark,
              userid: this.user.dUserid
            }
            this.btnLoading = true
            addOrEditPurchaseControl(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
